<template>
    <Splide v-if="contentFiltered.length" :options="splideOptions">
        <SplideSlide
            v-for="i in contentFiltered"
            :key="i.id">
            <article class="tw-relative tw-mx-auto tw-flex tw-h-full tw-flex-col tw-overflow-hidden tw-rounded-3xl tw-bg-gray-40 tw-px-8 tw-py-10 3xl:tw-px-14 3xl:tw-py-10">
                <p class="tw-text-sm tw-text-ioacademy tw-mb-3">{{ i.area.name }}</p>
                <div
                    v-if="i.text"
                    class="lg:tw-text-base tw-text-sm tw-grow tw-mb-8"
                    v-html="i.text"></div>
                <div class="tw-flex tw-flex-row tw-gap-4 tw-items-center tw-justify-between lg:tw-text-base tw-text-sm">
                    <div>
                        <p class="tw-font-semibold">{{ i.name }}</p>
                        <p class="tw-font-medium tw-text-gray-800">{{ i.occupation }}</p>
                    </div>
                    <Quotations class="tw-text-ioacademy tw-h-8 tw-w-8 lg:tw-h-11 lg:tw-w-11" />
                </div>
            </article>
        </SplideSlide>
    </Splide>
</template>

<script setup lang="ts">
    import { Splide, SplideSlide } from '@splidejs/vue-splide';
    import { useMedia } from '../composables/useMedia';
    import moment from 'moment'

    const props = defineProps<{
        content: any[];
    }>();

    const contentFiltered = computed(() => {
        return props.content.filter((item) => item.area);
    });

    function formatDate(date: string) {
        return moment(date).format('DD/MM/YYYY');
    }

    const splideOptions = ref({
        type: 'slide',
        perPage: 3,
        perMove: 1,
        gap: '2rem',
        pagination: false,
        arrows: props.content.length > 3,
        autoplay: props.content.length > 3,
        interval: 2000,
        rewind: true,
        breakpoints: {
            1536: {
                perPage: 2,
                arrows: props.content.length > 2,
                autoplay: props.content.length > 2,
            },
            1279: {
                perPage: 2,
                arrows: props.content.length > 2,
                autoplay: props.content.length > 2,
                gap: '1rem',
            },
            640: {
                perPage: 1,
                arrows: props.content.length > 1,
                autoplay: props.content.length > 1,
                gap: '1rem',
            },
        },
    });
</script>

<style scoped>
    article {
        background: rgb(var(--v-theme-gray-40)) url('@/assets/gradients/gradient-ioacademy-testemonies.png');
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
    }
</style>
